module.exports = __webpack_public_path__ + "media/fr_ca_s1_Allese.f6821606.oga";